/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { flushPendingConsents } from "../../../api/request/Consents/Consents.service";
import { isNativeMode, organicNativeEnabled } from "../../../native/nativeMode";
import { patchOrganicOffer, readOrganicOffer } from "../../../native/organicOffer";
import { campaignCouponToApply, keepsCurrentCoupon } from "../../../native/nativeCoupon";
import HttpLeadRepository from "../../../api/request/Lead/Lead.service";
import {
  GetlifeContext,
  LanguageT,
  useQuery,
} from "../../../context/GetLifeContext.context";
import { useNavigate } from "react-router";
import { GetLifeTrackerContext } from "../../../context/GetLifeTracker.context";
import { GetLifeCalculatorContext } from "../../../context/GetLifeCalculator.context";
import {
  GlobalAllowTelesubscription,
  GlobalPromoCodesToApply,
  formatPhoneWithCallCode,
} from "../../../utils/InternationlChanges";
import { hashIdentity } from "../../../utils/hashIdentity";
import { CapitalsResponse, DataPublicI } from "../../../api/request/Lead/Interfaces/DataInterface.response";
import { I18nContext } from "../../../context/i18n.context";
import { CALENDAR_MEET, DOMAIN, PARSE_DOCS } from "../../../constants/Global";
import { useDevice } from "get-life-storybook-ts";
import { isInViewport, parsePriceDecimal, annualizePremium, CONVERSION_CURRENCY } from "../../../utils/Utils";
import { DownloadableFilesT } from "get-life-storybook-ts/lib/components/DownloadableFiles/DownloadableFiles";
import HttpDocumentsRepository from "../../../api/request/Documents/Documents.service";
import HttpCouponsRepository from "../../../api/request/Coupons/Coupons.service";
import { getCookie } from "../../../hooks/getCookie";
import { useTraitState } from "../../../hooks/useTraitState";
import { usePendingCapitalAdjustment } from "../../../hooks/usePendingCapitalAdjustment";
import { TraitBoundary } from "../../../api/request/Lead/Interfaces/TraitTypes";
import { GuaranteeOption } from "../../NewUpsell/Components/GuaranteeToggles/GuaranteeToggles";
import numberFormat from "../../../utils/Utils";
import {
  track,
  trackContentOpened,
  trackCta,
  trackSubmissionError,
  trackValidationError,
} from "../../../helpers/Tracking";
import { createQuoteTracker } from "../../../helpers/Tracking/quote";

const QuotePageController = () => {
  const {
    init,
    leadId,
    setBrokerId,
    setLeadId,
    setToken,
    token,
    setThemeColor,
    setLogo,
    utm_source,
    utm_campaign,
    utm_medium,
    utm_content,
    utm_term,
    utm_test,
    gclid,
    gbraid,
    wbraid,
    msclkid,
    fbclid,
    getEntryPage,
    getReferrerUrl,
    getABTestVersion,
  } = useContext(GetlifeContext);
  const { handleTrackerQuestion, identifyFS } = useContext(
    GetLifeTrackerContext
  );
  const {
    state: { translate },
  } = useContext(I18nContext);
  const { navigateBack } = useContext(GetLifeCalculatorContext);

  let query = useQuery();
  const { isMobile } = useDevice();
  const navigate = useNavigate();
  const lead = query.get("lead");

  const urlParams = new URLSearchParams(window.location.search);

  const [price, setPrice] = useState<number>(0);
  const [quoteData, setQuoteData] = useState<DataPublicI | null>(null);
  const [loadingQuote, setLoadingQuote] = useState<boolean>(true);
  const [isCouponApplied, setIsCouponApplied] = useState<boolean>(false);
  const [coupon, setCoupon] = useState<string>("");
  const [pricePromotion, setPricePromotion] = useState<any>();
  const [afterPromoText, setAfterPromoText] = useState<string>("");
  const [beforePromoText, setBeforePromoText] = useState<string>("");
  const [hasTelesubscription, setHasTelesubscription] =
    useState<boolean>(false);
  const [btnContractLabel, setBtnContractLabel] = useState<string>(
    translate("calculatorPage.question.continue")
  );
  const [downloadableFiles, setDownloadableFiles] =
    useState<DownloadableFilesT>();
  const [downloadableLoading, setDownloadableLoading] =
    useState<boolean>(false);
  const [flagLink, setFlagLink] = useState<boolean>(false);
  const [isStickyVisible, setIsStickyVisible] = useState<Boolean>(false);
  const linkRefCall = useRef<any>();

  const [initialTraitCapitals, setInitialTraitCapitals] = useState<Record<string, number>>({ DEATH: 0 });
  const [traitBoundariesData, setTraitBoundariesData] = useState<TraitBoundary[]>([]);
  const [globalAccMax, setGlobalAccMax] = useState(0);

  const leadRepository = new HttpLeadRepository(leadId, token);
  const couponsRepository = new HttpCouponsRepository(leadId, token);

  const convertCapitals = (capitals: CapitalsResponse) => {
    const initialCapitals: Record<string, number> = {};
    const boundaries: TraitBoundary[] = [];

    for (const [trait, entry] of Object.entries(capitals)) {
      if (entry.active) {
        initialCapitals[trait] = entry.capital;
      }
      boundaries.push({
        trait,
        available: entry.available,
        min: entry.min,
        max: entry.max,
      });
    }

    return { initialCapitals, traitBoundaries: boundaries };
  };

  const {
    pendingAdjustment,
    captureAdjustmentError,
    confirmAdjustment,
    cancelAdjustment,
  } = usePendingCapitalAdjustment();

  const runTraitRecalculation = useCallback(
    async (capitals: Record<string, number>) => {
      // Organic native: el lead no vive en el monolito (PUT /lead/traits → 401).
      // El capital es el de la oferta en sesión: se parchea y fetQuoteData
      // re-tarifica con /organic/quote; el upsell native parte de ese capital.
      if (organicNativeEnabled() && isNativeMode() && null !== readOrganicOffer()) {
        if ("number" === typeof capitals.DEATH) {
          patchOrganicOffer({ capital: capitals.DEATH });
        }
        await fetQuoteData(lead || leadId);
        return;
      }
      const repo = new HttpLeadRepository(leadId, token);
      await repo.calculateMultiTraitPrices(leadId, capitals);
      await fetQuoteData(lead || leadId);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [leadId, lead, token]
  );

  const onTraitRecalculate = useCallback(async (newCapitals: Record<string, number>) => {
    setLoadingQuote(true);
    try {
      await runTraitRecalculation(newCapitals);
    } catch (error) {
      // Capital fuera de límites: el servidor propone un ajuste (error de validación).
      if (captureAdjustmentError(error, newCapitals)) trackValidationError("capital", "api");
      else trackSubmissionError(error);
      setLoadingQuote(false);
    }
  }, [runTraitRecalculation, captureAdjustmentError]);

  const confirmPendingAdjustment = useCallback(async () => {
    await confirmAdjustment(async (adjustedCapitals) => {
      setLoadingQuote(true);
      try {
        await runTraitRecalculation(adjustedCapitals);
      } catch {
        setLoadingQuote(false);
      }
    });
  }, [confirmAdjustment, runTraitRecalculation]);

  const cancelPendingAdjustment = async () => {
    cancelAdjustment();
    try {
      await fetQuoteData(lead || leadId);
    } catch {
      /* silenced: keep current state if refresh fails */
    }
  };

  const pendingAdjustmentModal = pendingAdjustment
    ? {
        isOpen: true,
        title: translate("edit.projects.capital.confirm.title"),
        message: translate("edit.projects.capital.adjusted")
          .replace(
            "{trait}",
            translate(`trait.${pendingAdjustment.trait}`) ||
              pendingAdjustment.trait
          )
          .replace(
            "{capital}",
            numberFormat(pendingAdjustment.deathCapital, "capital") as string
          ),
        acceptLabel: translate("edit.projects.capital.confirm.accept"),
        cancelLabel: translate("edit.projects.capital.confirm.cancel"),
        onConfirm: confirmPendingAdjustment,
        onCancel: cancelPendingAdjustment,
      }
    : {
        isOpen: false,
        title: "",
        message: "",
        acceptLabel: "",
        cancelLabel: "",
        onConfirm: () => {},
        onCancel: cancelAdjustment,
      };

  const traitState = useTraitState({
    initialCapitals: initialTraitCapitals,
    traitBoundaries: traitBoundariesData,
    globalAccumulatedMax: globalAccMax,
    onRecalculate: onTraitRecalculate,
  });

  const TRAIT_ICONS: Record<string, string> = {
    DEATH: "HeartIcon",
    DISABILITY: "DisabledIcon",
    SERIOUS_ILLNESS: "ShieldCheckIcon",
  };

  const TRAIT_LABELS: Record<string, string> = {
    DEATH: translate("trait.DEATH") || "Fallecimiento",
    DISABILITY: translate("trait.DISABILITY") || "Incapacidad",
    SERIOUS_ILLNESS: translate("trait.SERIOUS_ILLNESS") || "Enfermedad grave",
    MALATTIA_TERMINALE: translate("trait.MALATTIA_TERMINALE") || "Malattia terminale",
  };

  const MANDATORY_TRAITS = ["DEATH", "MALATTIA_TERMINALE"];
  const NON_EDITABLE_TRAITS = ["MALATTIA_TERMINALE"];

  const prepareGuarantees = (): GuaranteeOption[] => {
    const options: GuaranteeOption[] = [];

    for (const boundary of traitBoundariesData) {
      if (!boundary.available) continue;
      const isMandatory = MANDATORY_TRAITS.includes(boundary.trait);
      const isActive = isMandatory || traitState.isTraitActive(boundary.trait);
      options.push({
        key: boundary.trait,
        label: TRAIT_LABELS[boundary.trait] ?? boundary.trait,
        icon: TRAIT_ICONS[boundary.trait] ?? "ShieldCheckIcon",
        enabled: !isMandatory,
        active: isActive,
        loading: traitState.loading,
        disabledReason: isMandatory ? translate("upsell.guarantees.mandatory") : undefined,
        capital: isActive ? traitState.capitalsByTrait[boundary.trait] : undefined,
        minCapital: boundary.min,
        maxCapital: boundary.max,
        editableCapital: !NON_EDITABLE_TRAITS.includes(boundary.trait),
      });
    }

    return options;
  };

  const guaranteeOptions = prepareGuarantees();

  const handleGuaranteeToggle = (key: string) => {
    traitState.toggleTrait(key);
  };

  const handleCapitalChange = (key: string, newCapital: number) => {
    traitState.setTraitCapital(key, newCapital);
  };

  const getToken = () => {
    leadRepository.getToken(lead || leadId).then((res) => {
      const { token, brokerId, email } = res;

      if (!token) {
        console.log("[QuotePage] redirect to /login: getToken returned no token", { lead, leadId });
        init("no_token", false);
        navigate("/login");
      } else {
        setToken(token);
        setBrokerId(brokerId);
        flushPendingConsents(lead || leadId, token);
        identifyFS({
          lead: leadId,
          data: {
            emailDomain: email?.split("@")[1],
            email: email,
            brokerId: brokerId,
          },
        });
      }
    });
  };

  useEffect(() => {
    if (lead && !token) getToken();
  }, []);

  const conditionsPrice = (decimal?: string) => {
    const effectivePrice = pricePromotion ?? price;
    return parsePriceDecimal(effectivePrice, decimal && "decimal");
  };

  const documentsRepository = new HttpDocumentsRepository(leadId, token);

  const getAvailablesDocuments = async (lead: string) => {
    try {
      documentsRepository.getAvailablesDocuments(lead).then((resp) => {
        let allDocs: DownloadableFilesT = [
          {
            label: "",
            type: "",
          },
        ];
        resp.forEach((element: string) => {
          allDocs.push({
            label: PARSE_DOCS(translate)[0][element],
            type: element,
          });
        });
  
        setDownloadableFiles(allDocs!);
      });
    } catch (error) {
      setDownloadableFiles([{
            label: "",
            type: "",
          },]);
    }
  };

  const downloadDocument = async (type: string) => {
    // content_opened (telemetría): IPID, condiciones, nota legal… por su tipo.
    trackContentOpened(`doc_${String(type).toLowerCase()}`);
    documentsRepository.downloadDocument(type).then((res) => {
      window.open(res.documentUrl, "_blank");
    });
  };

  useEffect(() => {
    // Organic native: getAvailablesDocuments va al monolito (/documents/availables)
    // y el lead born-native no existe allí → 401. No es crítico en el quote; se omite.
    if (token && lead && !isNativeMode()) getAvailablesDocuments(lead);
  }, [token, lead]);

  const prepareLeadForQuestions = (route: string) => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    navigate(route);
  };

  const navigateToQuestions = () => {
    // Organic native: no hay paso de product-questions propio; coverage/effectDate/
    // residencia/PEP van dentro del cuestionario médico (mismo confirm → UW). Se
    // salta directo a /medicalQuestions.
    prepareLeadForQuestions(isNativeMode() ? "/medicalQuestions" : "/productQuestions");
  };

  const buildQuoteEventPayload = (data: DataPublicI) => {
    const regularPrice = data.priceSummary?.regularPrice ?? data.price;
    const promotedPrice = data.priceSummary?.priceToPay;

    return {
      page: window.location.href,
      leadId: leadId,
      intent: data.intention,
      calculatedCapital: data.capitals?.DEATH?.capital ?? data.capital,
      calculatedPremium: annualizePremium(regularPrice, "monthly"),
      discountedPremium: annualizePremium(promotedPrice ?? regularPrice, "monthly"),
      currency: CONVERSION_CURRENCY,
      coverage: data.coverage === "premium" ? "FIPA" : "F",
      utm_source: utm_source,
      utm_campaign: utm_campaign,
      utm_medium: utm_medium,
      utm_content: utm_content,
      utm_term: utm_term,
      utm_test: utm_test,
      gclid: gclid,
      gbraid: gbraid,
      wbraid: wbraid,
      msclkid: msclkid,
      fbclid: fbclid,
      platform: "App",
      entryPage: getEntryPage(),
      referrerUrl: getReferrerUrl(),
      ABTestVersion: getABTestVersion(),
    };
  };

  const sendQuoteEvent = async (event: string, data: DataPublicI) => {
    const dataInfo = buildQuoteEventPayload(data);
    const leadInfo = leadId
      ? await leadRepository.getInfoLead().catch(() => null)
      : null;
    const identityInfo = leadInfo
      ? await hashIdentity({
          email: leadInfo.email,
          phone: formatPhoneWithCallCode(leadInfo.phone),
        })
      : {};

    handleTrackerQuestion({
      type: "FS",
      event,
      data: {
        birthDate: data.dateOfBirth ? new Date(data.dateOfBirth) : undefined,
        ...dataInfo,
        ...identityInfo,
      },
    });

    handleTrackerQuestion({
      type: "GA",
      data: {
        event,
        birthDate: data.dateOfBirth,
        ...dataInfo,
        ...identityInfo,
      },
    });
  };

  const quoteViewedSentRef = useRef(false);
  // Telemetría 3.1: quote_viewed una vez por entrada en el paso de precio (esta
  // pantalla montada) y quote_changed por cada precio distinto después.
  const quoteTrackerRef = useRef(createQuoteTracker());
  useEffect(() => {
    if (quoteData && !quoteViewedSentRef.current) {
      quoteViewedSentRef.current = true;
      sendQuoteEvent("calculatorQuoteViewed", quoteData);
    }
    if (quoteData) {
      const quote = {
        capital: quoteData.capitals?.DEATH?.capital ?? quoteData.capital ?? null,
        price:
          quoteData.priceSummary?.priceToPay ??
          quoteData.priceSummary?.regularPrice ??
          quoteData.price ??
          null,
        // La pantalla de precio siempre enseña la cuota mensual.
        period: "monthly",
        coverage: quoteData.coverage ?? null,
      };
      quoteTrackerRef.current(quote);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteData]);

  const handleButtonQuote = () => {
    if (quoteData) sendQuoteEvent("calculatorQuoteGenerated", quoteData);
    if (
      hasTelesubscription &&
      GlobalAllowTelesubscription[DOMAIN! as LanguageT]
    ) {
      trackCta("meeting");
      window.open(CALENDAR_MEET);
    } else {
      navigateToQuestions();
    }
  };

  const getBtnContractButtonLabel = (telesubscription: boolean) => {
    if (telesubscription) {
      setBtnContractLabel(
        translate(translate("telesubscription.button.calendar"))
      );
    } else {
      setBtnContractLabel(translate("calculatorPage.question.continue"));
    }
  };


  const preparePromoText = (data: DataPublicI) => {
    if (coupon === "10_sconto" || coupon === "facile" || coupon === "segugio10") {
      setAfterPromoText(`Al posto di ${data.price} € `);
      setBeforePromoText("");
    } else {
      setAfterPromoText(data.afterPromoText ?? "");
      setBeforePromoText(data.beforePromoText ?? "");
    }
  }

  // Native: el código de campaña (gtf_campaign, p. ej. segugio10) va a ms-agl por
  // el gateway, una vez por lead y sin pisar un cupón que el lead ya lleve. Si
  // ms-agl no lo conoce o los cupones están apagados, sigue el de por defecto.
  const nativeCampaignCouponLead = useRef<string | null>(null);
  const applyNativeCampaignCoupon = async (leadId: string) => {
    const code = campaignCouponToApply(
      urlParams.get("gtf_campaign"),
      getCookie("gtf_campaign"),
      GlobalPromoCodesToApply[DOMAIN as LanguageT]
    );
    if (null === code || nativeCampaignCouponLead.current === leadId) return;
    nativeCampaignCouponLead.current = leadId;
    const repository = new HttpCouponsRepository(leadId, token);
    try {
      if (keepsCurrentCoupon(await repository.nativeCoupon())) return;
      await repository.applyNativeCoupon(code);
      track("promo_applied", { code });
      handleTrackerQuestion({
        type: "FS",
        event: `appliedCoupon`,
        data: { promotionalCode: code, leadId, market: DOMAIN },
      });
    } catch (error) {
      // Código que ms-agl no tiene (p. ej. facile) o cupones apagados.
    }
  };

  const fetchApplyCoupon = async (leadId: string) => {
    const gtf_url = urlParams.get("gtf_campaign");
    const gtf_campaign = getCookie("gtf_campaign");
    const isCoupon = gtf_url || gtf_campaign || GlobalPromoCodesToApply[DOMAIN as LanguageT];
    setCoupon(isCoupon || "");
    try {
      await couponsRepository.applyCouponQuote({
        code: isCoupon!,
        leadId: leadId,
      });
      if (isCoupon) track("promo_applied", { code: isCoupon });
      handleTrackerQuestion({
        type: "FS",
        event: `appliedCoupon`,
        data: {
          promotionalCode: isCoupon,
          leadId: lead,
          market: DOMAIN,
        },
      });
      setIsCouponApplied(true);
    } catch (error) {
      fetQuoteData(lead!);
    }
  };

  const fetQuoteData = async (newLead: string) => {
    try {
      setLoadingQuote(true);
      const response: DataPublicI = await leadRepository.getQuoteData(newLead);
      setThemeColor(response.themeColor);
      setLogo(response.logo);
      setLeadId(newLead);
      setHasTelesubscription(response.hasTelesubscription);
      getBtnContractButtonLabel(response.hasTelesubscription);
      setPrice(response.price);
      setQuoteData(response);
      preparePromoText(response);
      if (response?.priceSummary?.hasDiscount) {
        if (response.priceSummary.priceToPay === 1.01) {
          setPricePromotion(1.0);
        } else {
          setPricePromotion(response.priceSummary.priceToPay);
        }
      }

      if (response.capitals) {
        const { initialCapitals, traitBoundaries } = convertCapitals(response.capitals);
        setInitialTraitCapitals(initialCapitals);
        setTraitBoundariesData(traitBoundaries);
        setGlobalAccMax(response.globalAccumulatedMax ?? 0);
      }

      setLoadingQuote(false);
    } catch (error: any) {
      console.log("[QuotePage] redirect to /login: fetQuoteData failed", { error, status: error?.status, newLead });
      setLoadingQuote(false);
      if (error?.status === 424) {
        return;
      }
      trackSubmissionError(error);
      init("token_not_authorized", false);
      navigate("/login");
    }
  };

  useEffect(() => {
    (async () => {
      if (lead && token) {
        const gtf_url = urlParams.get("gtf_campaign");
        const gtf_campaign = getCookie("gtf_campaign");
        if (
          (gtf_url || gtf_campaign || GlobalPromoCodesToApply[DOMAIN as LanguageT]) &&
          !isCouponApplied && gtf_url !== "neopension" &&
          // Organic native: el cupón del monolito (/coupon/quote/apply) no aplica a
          // un lead born-native (401). El descuento 10_sconto es native (ms-agl).
          !isNativeMode()
        ) {
          await fetchApplyCoupon(lead);
        } else {
          if (isNativeMode()) await applyNativeCampaignCoupon(lead);
          await fetQuoteData(lead);
        }
      }
    })();
  }, [lead, token, isCouponApplied]);

  useEffect(() => {
    if (flagLink) {
      linkRefCall.current?.click();
      setFlagLink(false);
    }
  }, [flagLink]);

  useEffect(() => {
    setHasTelesubscription(hasTelesubscription);
  }, [hasTelesubscription]);

  useEffect(() => {
    const toggleStickyBar = () => {
      const quoteBanner = document.getElementById("quote_page_banner");
      const isCTAInViewport: Boolean = isInViewport(quoteBanner);
      if (isCTAInViewport === isStickyVisible) {
        setIsStickyVisible(!isCTAInViewport);
      }
    };
    document.addEventListener("scroll", toggleStickyBar);
    return () => window.removeEventListener("scroll", toggleStickyBar);
  }, [isStickyVisible]);

  return {
    price,
    btnContractLabel,
    conditionsPrice,
    downloadableFiles,
    downloadableLoading,
    downloadDocument,
    handleButtonQuote,
    hasTelesubscription,
    isMobile,
    linkRefCall,
    loadingQuote,
    navigateBack,
    setFlagLink,
    translate,
    afterPromoText,
    beforePromoText,
    isStickyVisible,
    guaranteeOptions,
    handleGuaranteeToggle,
    handleCapitalChange,
    traitState,
    pendingAdjustmentModal,
  };
};

export default QuotePageController;
